import React from "react";
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import './style/logout.css';
import logo from './assets/logo.png';
import firebaseApp from './firebaseApp';
import Button from "@material-ui/core/IconButton";

// remove the value in the local storage
const handleClickApp = event => {  
    localStorage.clear();
};

function Copyright() {
    return (
        <Typography variant="body2" color="textPrimary" align="center">
            <b>{'Copyright © '}
            <Link href="https://isitphishy.wixsite.com/website" target="_blank">
                Phishy
            </Link>{' '}
            {new Date().getFullYear()}</b>
            {'.'}
        </Typography>
    );
}

function Logout() {
    
    return (
        <div className="contentContainer">
            <div className="logoutSectionContent">
                <img src={logo} className="App-logo" alt="logo"/><br />
                <p className="pageHeader">Log out</p> 
                <hr />
                <br />

                <Button className="btnConfirm" onClick={() => {firebaseApp.auth().signOut(); handleClickApp();}}> Confirm </Button>
                <Button className="btnCancel" onClick={() => window.history.back()}>Cancel</Button>
                <Box mt={8}>
                    <Copyright />
                </Box>
            </div>
        </div>

    );
}

export default Logout;
